import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import type { PermissionGroupRow } from "../types/permissionGroups";

export function usePermissionGroupColumns(): ColumnDef<PermissionGroupRow>[] {
    return [
        {
            id: "select",
            header: ({ table }) => (
                <Checkbox
                    checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                    onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                    aria-label="Select all"
                />
            ),
            cell: ({ row }) => (
                <Checkbox
                    checked={row.getIsSelected()}
                    onCheckedChange={(v) => row.toggleSelected(!!v)}
                    aria-label="Select row"
                    onClick={(e) => e.stopPropagation()}
                />
            ),
            size: 50,
            minSize: 50,
            maxSize: 50,
            enableSorting: false,
            enableResizing: false,
        },
        { accessorKey: "id", header: "ID" },
        { accessorKey: "name", header: "그룹명" },
        { accessorKey: "grantPreview", header: "권한" },
    ];
}